import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
};

export type ArticoliImmaginiCollezioniObject = {
  __typename?: 'ArticoliImmaginiCollezioniObject';
  finituraNome?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  tonalitaNome?: Maybe<Scalars['String']>;
  tonalitaUrl?: Maybe<Scalars['String']>;
};

export type ArticoliNode = {
  __typename?: 'ArticoliNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  articolicollezioni: Array<CollezioneNode>;
  bcra?: Maybe<Scalars['String']>;
  caratteristichearticoli: Array<CaratteristicheNode>;
  catalogo?: Maybe<Scalars['Boolean']>;
  categoriaDecoro?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  codice: Scalars['String'];
  codiceCatalogo?: Maybe<Scalars['String']>;
  codiceWeb?: Maybe<Scalars['String']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  dcof?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  effettoMatericoId?: Maybe<Scalars['Int']>;
  finituraId?: Maybe<Scalars['Int']>;
  fondo?: Maybe<Scalars['Boolean']>;
  formatiarticoli: Array<FormatiNode>;
  galleryArticle: Array<ImmaginiArticoliNode>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  immaginicollartMm: Array<ImmaginiCollezioniNode>;
  nome?: Maybe<Scalars['String']>;
  nomeWeb?: Maybe<Scalars['String']>;
  ordinamentoDecoro?: Maybe<Scalars['Int']>;
  pendoloAS4586?: Maybe<Scalars['String']>;
  pendoloBS7976?: Maybe<Scalars['String']>;
  pendoloUNE41901?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  superficiarticoli: Array<SuperficieNode>;
  superficie?: Maybe<SuperficieNode>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  tonalita?: Maybe<TonalitaNode>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  xTonalitaCollezioni: Array<TonalitaCollezioneNode>;
};

export type AudioDescrizioneNode = {
  __typename?: 'AudioDescrizioneNode';
  audioFiles?: Maybe<Array<Maybe<AudioFileNode>>>;
  changedDate?: Maybe<Scalars['DateTime']>;
  collezione?: Maybe<CollezioneNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  model?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  restoreCollezioneSlug?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
};

export type AudioFileNode = {
  __typename?: 'AudioFileNode';
  audio: AudioDescrizioneNode;
  changedDate?: Maybe<Scalars['DateTime']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  cta?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pk?: Maybe<Scalars['Int']>;
};

export type BrandNode = {
  __typename?: 'BrandNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['Int']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  /** Claim */
  claim?: Maybe<Scalars['String']>;
  /** Claim */
  claimDe?: Maybe<Scalars['String']>;
  /** Claim */
  claimEn?: Maybe<Scalars['String']>;
  /** Claim */
  claimEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimFr?: Maybe<Scalars['String']>;
  /** Claim */
  claimIt?: Maybe<Scalars['String']>;
  /** Claim */
  claimUs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsFr?: Maybe<Scalars['String']>;
  /** code */
  codice: Scalars['String'];
  collezioni?: Maybe<Array<Maybe<CollezioneNode>>>;
  correlati?: Maybe<Array<Maybe<BrandNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitolo?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloDe?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEn?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloFr?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloIt?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsFr?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  documentiBrand: Array<DocumentiBrandNode>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  immagineHome?: Maybe<Scalars['String']>;
  immagineStatica?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeo?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoDe?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoEn?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoEs?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoFr?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoIt?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoUs?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoUsEs?: Maybe<Scalars['String']>;
  /** Testo SEO P Listing Collezioni */
  listingTestoSeoUsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1De?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1En?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1It?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 Listing Collezioni */
  listingTitoloSeoH1UsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2De?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2En?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2It?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 Listing Collezioni */
  listingTitoloSeoH2UsFr?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  logoTransparent?: Maybe<Scalars['String']>;
  magazinebrands: Array<MagazineNode>;
  magazines?: Maybe<Array<Maybe<MagazineNode>>>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modelPk?: Maybe<Scalars['Int']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  /** Nome */
  nome?: Maybe<Scalars['String']>;
  /** Nome */
  nomeDe?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEn?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeFr?: Maybe<Scalars['String']>;
  /** Nome */
  nomeIt?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsFr?: Maybe<Scalars['String']>;
  pageActive: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  path?: Maybe<Scalars['String']>;
  /** Payoff */
  payoff?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffDe?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEn?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffFr?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffIt?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  progetti?: Maybe<Array<Maybe<ProgettiNode>>>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: ProdottiBrandStatoPubblicazioneChoices;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  titolo: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

export type BreadcrumbType = {
  __typename?: 'BreadcrumbType';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CaratteristicheNode = {
  __typename?: 'CaratteristicheNode';
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  ambientale?: Maybe<Scalars['Boolean']>;
  caratteristichearticoli: Array<ArticoliNode>;
  caratteristichecollezioni: Array<CollezioneNode>;
  caratteristichepadre?: Maybe<CaratteristichePadreNode>;
  /** code */
  codice: Scalars['String'];
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  fileDocumentazione?: Maybe<Scalars['String']>;
  /** id */
  id: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  /** nome */
  nome: Scalars['String'];
  ordinamento?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  pathDocumentazione?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlDocumentazione?: Maybe<Scalars['String']>;
};

export type CaratteristichePadreNode = {
  __typename?: 'CaratteristichePadreNode';
  caratteristiche: Array<CaratteristicheNode>;
  children?: Maybe<Array<Maybe<CaratteristicheNode>>>;
  codice?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  fileDocumentazione?: Maybe<Scalars['String']>;
  fileIcona?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  pathDocumentazione?: Maybe<Scalars['String']>;
  pathIcona?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlDocumentazione?: Maybe<Scalars['String']>;
};

export type CategoriaDecoriObject = {
  __typename?: 'CategoriaDecoriObject';
  categoria?: Maybe<Scalars['String']>;
  decori?: Maybe<Array<Maybe<DecoroObject>>>;
};

export type CategoriaMagazineNode = {
  __typename?: 'CategoriaMagazineNode';
  id: Scalars['ID'];
  magazine: Array<MagazineNode>;
  pk?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
};

export type CategoriaNode = {
  __typename?: 'CategoriaNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivello?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloDe?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloEn?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloEs?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloFr?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloIt?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloUs?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloUsEs?: Maybe<Scalars['String']>;
  /** Descrizione per categorie di terzo livello */
  descriptionTerzoLivelloUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  macrocategoria?: Maybe<MacroCategoriaNode>;
  mainImage?: Maybe<Scalars['String']>;
  modelPk?: Maybe<Scalars['Int']>;
  nome: Scalars['String'];
  nomeTipologieimmaginicollezioni?: Maybe<Scalars['String']>;
  objectId: Scalars['Int'];
  /** ordinamento */
  ordinamento?: Maybe<Scalars['Int']>;
  /** ordinamento */
  ordinamentoSoluzioni?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivello?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloDe?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloEn?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloEs?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloFr?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloIt?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloUs?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloUsEs?: Maybe<Scalars['String']>;
  /** Titolo per categorie di terzo livello */
  titleTerzoLivelloUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  voceMenu: Scalars['String'];
  voceMenuDe?: Maybe<Scalars['String']>;
  voceMenuEn?: Maybe<Scalars['String']>;
  voceMenuEs?: Maybe<Scalars['String']>;
  voceMenuFr?: Maybe<Scalars['String']>;
  voceMenuIt?: Maybe<Scalars['String']>;
  voceMenuUs?: Maybe<Scalars['String']>;
  voceMenuUsEs?: Maybe<Scalars['String']>;
  voceMenuUsFr?: Maybe<Scalars['String']>;
};

export type CollezioneNode = {
  __typename?: 'CollezioneNode';
  abaco?: Maybe<ImmaginiCollezioniNode>;
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  articolicollezioni: Array<ArticoliNode>;
  audioItems: Array<AudioDescrizioneNode>;
  brand?: Maybe<BrandNode>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  caratteristichecollezioni: Array<CaratteristicheNode>;
  cataloghiBrochure?: Maybe<Array<Maybe<DocumentiCollezioniNode>>>;
  catalogo?: Maybe<DocumentiCollezioniNode>;
  categoriaEffetto?: Maybe<CategoriaNode>;
  certificazioni?: Maybe<Array<Maybe<CaratteristicheNode>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  claim?: Maybe<Scalars['String']>;
  /** Claim */
  claimDe?: Maybe<Scalars['String']>;
  /** Claim */
  claimEn?: Maybe<Scalars['String']>;
  /** Claim */
  claimEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimFr?: Maybe<Scalars['String']>;
  /** Claim */
  claimIt?: Maybe<Scalars['String']>;
  /** Claim */
  claimUs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsEs?: Maybe<Scalars['String']>;
  /** Claim */
  claimUsFr?: Maybe<Scalars['String']>;
  clickCounter?: Maybe<Scalars['Int']>;
  collezioniCollezioni: Array<CollezioneNode>;
  collezioniSet: Array<CollezioneNode>;
  colori?: Maybe<Array<Maybe<ColoriObject>>>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  dataIns?: Maybe<Scalars['Date']>;
  decori?: Maybe<Array<Maybe<CategoriaDecoriObject>>>;
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  descriptionSeo?: Maybe<Scalars['String']>;
  descriptionSeoDe?: Maybe<Scalars['String']>;
  descriptionSeoEn?: Maybe<Scalars['String']>;
  descriptionSeoEs?: Maybe<Scalars['String']>;
  descriptionSeoFr?: Maybe<Scalars['String']>;
  descriptionSeoIt?: Maybe<Scalars['String']>;
  descriptionSeoUs?: Maybe<Scalars['String']>;
  descriptionSeoUsEs?: Maybe<Scalars['String']>;
  descriptionSeoUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitolo?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloDe?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEn?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloFr?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloIt?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsEs?: Maybe<Scalars['String']>;
  /** Titolo Descrizione */
  descrizioneTitoloUsFr?: Maybe<Scalars['String']>;
  destinazioni?: Maybe<Array<Maybe<DestinazioneNode>>>;
  docuCollection: Array<DocumentiCollezioniNode>;
  effetto?: Maybe<IspirazioniObject>;
  formatiperpose: Array<FormatiNode>;
  gallery?: Maybe<Array<Maybe<ImmaginiCollezioniNode>>>;
  galleryCollection: Array<ImmaginiCollezioniNode>;
  id: Scalars['Int'];
  imageCopertina?: Maybe<Scalars['String']>;
  immagineVideo?: Maybe<ImmaginiCollezioniNode>;
  inevidenza?: Maybe<Scalars['Boolean']>;
  inevidenzaOrdinamento?: Maybe<Scalars['Int']>;
  infoProgetti: Array<InfoProgettoNode>;
  isUsa?: Maybe<Scalars['Boolean']>;
  ispirazioniCollezioni: Array<IspirazioniNode>;
  lappato?: Maybe<Scalars['Boolean']>;
  lappatoUrl?: Maybe<Scalars['String']>;
  linkVideo?: Maybe<Scalars['String']>;
  linkVideoDe?: Maybe<Scalars['String']>;
  linkVideoEn?: Maybe<Scalars['String']>;
  linkVideoEs?: Maybe<Scalars['String']>;
  linkVideoFr?: Maybe<Scalars['String']>;
  linkVideoIt?: Maybe<Scalars['String']>;
  linkVideoUs?: Maybe<Scalars['String']>;
  linkVideoUsEs?: Maybe<Scalars['String']>;
  linkVideoUsFr?: Maybe<Scalars['String']>;
  listingImage?: Maybe<ImmaginiCollezioniNode>;
  logo?: Maybe<Scalars['String']>;
  magazinecollezioni: Array<MagazineNode>;
  magazines?: Maybe<Array<Maybe<MagazineNode>>>;
  modelPk?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  /** Nome */
  nomeDe?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEn?: Maybe<Scalars['String']>;
  /** Nome */
  nomeEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeFr?: Maybe<Scalars['String']>;
  /** Nome */
  nomeIt?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsEs?: Maybe<Scalars['String']>;
  /** Nome */
  nomeUsFr?: Maybe<Scalars['String']>;
  novita?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaDe?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaEn?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaEs?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaFr?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaIt?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaUs?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaUsEs?: Maybe<Scalars['Boolean']>;
  /** Make this new content visible for this language */
  novitaUsFr?: Maybe<Scalars['Boolean']>;
  nsf?: Maybe<Scalars['Boolean']>;
  nsfDe?: Maybe<Scalars['Boolean']>;
  nsfEn?: Maybe<Scalars['Boolean']>;
  nsfEs?: Maybe<Scalars['Boolean']>;
  nsfFr?: Maybe<Scalars['Boolean']>;
  nsfIt?: Maybe<Scalars['Boolean']>;
  nsfMagazineSlug?: Maybe<Scalars['String']>;
  nsfTesto?: Maybe<Scalars['String']>;
  nsfTestoDe?: Maybe<Scalars['String']>;
  nsfTestoEn?: Maybe<Scalars['String']>;
  nsfTestoEs?: Maybe<Scalars['String']>;
  nsfTestoFr?: Maybe<Scalars['String']>;
  nsfTestoIt?: Maybe<Scalars['String']>;
  nsfTestoUs?: Maybe<Scalars['String']>;
  nsfTestoUsEs?: Maybe<Scalars['String']>;
  nsfTestoUsFr?: Maybe<Scalars['String']>;
  nsfUs?: Maybe<Scalars['Boolean']>;
  nsfUsEs?: Maybe<Scalars['Boolean']>;
  nsfUsFr?: Maybe<Scalars['Boolean']>;
  opuses?: Maybe<Array<Maybe<OpusNode>>>;
  ordinamento?: Maybe<Scalars['Int']>;
  payoff?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffDe?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEn?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffFr?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffIt?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsEs?: Maybe<Scalars['String']>;
  /** Payoff */
  payoffUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  prefissoTonalita?: Maybe<Scalars['String']>;
  progetti?: Maybe<Array<Maybe<ProgettiNode>>>;
  progettiCollezioni: Array<ProgettiNode>;
  quickship?: Maybe<Scalars['Boolean']>;
  quickshipDe?: Maybe<Scalars['Boolean']>;
  quickshipEn?: Maybe<Scalars['Boolean']>;
  quickshipEs?: Maybe<Scalars['Boolean']>;
  quickshipFr?: Maybe<Scalars['Boolean']>;
  quickshipIt?: Maybe<Scalars['Boolean']>;
  quickshipUs?: Maybe<Scalars['Boolean']>;
  quickshipUsEs?: Maybe<Scalars['Boolean']>;
  quickshipUsFr?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  shadeVariations?: Maybe<Array<Maybe<ShadeVariationNode>>>;
  shield?: Maybe<Scalars['Boolean']>;
  shieldDe?: Maybe<Scalars['Boolean']>;
  shieldEn?: Maybe<Scalars['Boolean']>;
  shieldEs?: Maybe<Scalars['Boolean']>;
  shieldFormatiSuperfici?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiDe?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiEn?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiEs?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiFr?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiIt?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiUs?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiUsEs?: Maybe<Scalars['String']>;
  shieldFormatiSuperficiUsFr?: Maybe<Scalars['String']>;
  shieldFr?: Maybe<Scalars['Boolean']>;
  shieldIt?: Maybe<Scalars['Boolean']>;
  shieldUs?: Maybe<Scalars['Boolean']>;
  shieldUsEs?: Maybe<Scalars['Boolean']>;
  shieldUsFr?: Maybe<Scalars['Boolean']>;
  silktech?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  spessoriFormati?: Maybe<Array<Maybe<SpessoriFormatiObject>>>;
  subtitleH1?: Maybe<Scalars['String']>;
  subtitleH1De?: Maybe<Scalars['String']>;
  subtitleH1En?: Maybe<Scalars['String']>;
  subtitleH1Es?: Maybe<Scalars['String']>;
  subtitleH1Fr?: Maybe<Scalars['String']>;
  subtitleH1It?: Maybe<Scalars['String']>;
  subtitleH1Us?: Maybe<Scalars['String']>;
  subtitleH1UsEs?: Maybe<Scalars['String']>;
  subtitleH1UsFr?: Maybe<Scalars['String']>;
  superfici?: Maybe<Array<Maybe<SuperficiObject>>>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  titleH1?: Maybe<Scalars['String']>;
  titleH1De?: Maybe<Scalars['String']>;
  titleH1En?: Maybe<Scalars['String']>;
  titleH1Es?: Maybe<Scalars['String']>;
  titleH1Fr?: Maybe<Scalars['String']>;
  titleH1It?: Maybe<Scalars['String']>;
  titleH1Us?: Maybe<Scalars['String']>;
  titleH1UsEs?: Maybe<Scalars['String']>;
  titleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  tonalitacollezioni: Array<TonalitaNode>;
  url?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  xTonalitaCollezioni: Array<TonalitaCollezioneNode>;
};

export type ColoriObject = {
  __typename?: 'ColoriObject';
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  tonalita?: Maybe<Array<Maybe<TonalitaColoriObject>>>;
};

export type DecoroObject = {
  __typename?: 'DecoroObject';
  categoriaDecoro?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<ImmaginiArticoliNode>;
  nomeWeb?: Maybe<Scalars['String']>;
  styleHeight?: Maybe<Scalars['Int']>;
  styleWidth?: Maybe<Scalars['Int']>;
};

export type DestinazioneNode = {
  __typename?: 'DestinazioneNode';
  active?: Maybe<Scalars['Boolean']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloDe?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloFr?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloUs?: Maybe<Scalars['String']>;
  titoloUsEs?: Maybe<Scalars['String']>;
  titoloUsFr?: Maybe<Scalars['String']>;
};

export type DestinazioneSoluzioneNode = {
  __typename?: 'DestinazioneSoluzioneNode';
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  soluzioni: Array<SoluzioneNode>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
};

export type DestinazioneUsoNode = {
  __typename?: 'DestinazioneUsoNode';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  progetti: Array<ProgettiNode>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloDe?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloFr?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloUs?: Maybe<Scalars['String']>;
  titoloUsEs?: Maybe<Scalars['String']>;
  titoloUsFr?: Maybe<Scalars['String']>;
};

export type DocumentiBrandNode = {
  __typename?: 'DocumentiBrandNode';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<BrandNode>;
  dataIns?: Maybe<Scalars['DateTime']>;
  dataUltMod?: Maybe<Scalars['DateTime']>;
  file?: Maybe<Scalars['String']>;
  fileHead?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lingua?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  tipologie?: Maybe<TipologieNode>;
  url?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type DocumentiCollezioniNode = {
  __typename?: 'DocumentiCollezioniNode';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<BrandNode>;
  countdown?: Maybe<Scalars['Int']>;
  docuCollection?: Maybe<CollezioneNode>;
  file: Scalars['String'];
  id: Scalars['Int'];
  nomeWeb?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  tipologiedocumenti?: Maybe<TipologieNode>;
  titledocu?: Maybe<Scalars['String']>;
  titledocuDe?: Maybe<Scalars['String']>;
  titledocuEn?: Maybe<Scalars['String']>;
  titledocuEs?: Maybe<Scalars['String']>;
  titledocuFr?: Maybe<Scalars['String']>;
  titledocuIt?: Maybe<Scalars['String']>;
  titledocuUs?: Maybe<Scalars['String']>;
  titledocuUsEs?: Maybe<Scalars['String']>;
  titledocuUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FiltroCollezioneInputObject = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  valori?: InputMaybe<Array<InputMaybe<FiltroValoreInputObject>>>;
};

export type FiltroCollezioneObject = {
  __typename?: 'FiltroCollezioneObject';
  chiave?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  valori?: Maybe<Array<Maybe<FiltroValoreObject>>>;
};

export type FiltroValoreInputObject = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

export type FiltroValoreObject = {
  __typename?: 'FiltroValoreObject';
  chiave?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
};

export type FormatiNode = {
  __typename?: 'FormatiNode';
  active?: Maybe<Scalars['Boolean']>;
  formatiarticoli: Array<ArticoliNode>;
  formatiperpose: Array<CollezioneNode>;
  formatoOpuscode: Array<OpusCodeNode>;
  id?: Maybe<Scalars['Int']>;
  infoProgetti: Array<InfoProgettoNode>;
  lato1Cm?: Maybe<Scalars['String']>;
  lato1Denominatore?: Maybe<Scalars['String']>;
  lato1Intero?: Maybe<Scalars['String']>;
  lato1Numeratore?: Maybe<Scalars['String']>;
  lato1PxWeb?: Maybe<Scalars['String']>;
  lato2Cm?: Maybe<Scalars['String']>;
  lato2Denominatore?: Maybe<Scalars['String']>;
  lato2Intero?: Maybe<Scalars['String']>;
  lato2Numeratore?: Maybe<Scalars['String']>;
  lato2PxWeb?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  rangeWeb?: Maybe<Scalars['Int']>;
};

export type FormatiSpessoriObject = {
  __typename?: 'FormatiSpessoriObject';
  lato1Denominatore?: Maybe<Scalars['String']>;
  lato1Intero?: Maybe<Scalars['String']>;
  lato1Numeratore?: Maybe<Scalars['String']>;
  lato2Denominatore?: Maybe<Scalars['String']>;
  lato2Intero?: Maybe<Scalars['String']>;
  lato2Numeratore?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  spessoriarticoliCodice?: Maybe<Scalars['String']>;
};

export type GalleryItemNode = {
  __typename?: 'GalleryItemNode';
  filePath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  news: MagazineNode;
  order: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
};

export type HrefLangType = {
  __typename?: 'HrefLangType';
  href?: Maybe<Scalars['String']>;
  hrefLang?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type ImmaginiArticoliNode = {
  __typename?: 'ImmaginiArticoliNode';
  active?: Maybe<Scalars['Boolean']>;
  cropDisabled: Scalars['Boolean'];
  dataUltMod?: Maybe<Scalars['DateTime']>;
  file: Scalars['String'];
  galleryArticle?: Maybe<ArticoliNode>;
  id?: Maybe<Scalars['Int']>;
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
  visualizzazioniId: Scalars['Int'];
};

export type ImmaginiCollezioniNode = {
  __typename?: 'ImmaginiCollezioniNode';
  active?: Maybe<Scalars['Boolean']>;
  altTag?: Maybe<Scalars['String']>;
  altTagDe?: Maybe<Scalars['String']>;
  altTagEn?: Maybe<Scalars['String']>;
  altTagEs?: Maybe<Scalars['String']>;
  altTagFr?: Maybe<Scalars['String']>;
  altTagIt?: Maybe<Scalars['String']>;
  altTagUs?: Maybe<Scalars['String']>;
  altTagUsEs?: Maybe<Scalars['String']>;
  altTagUsFr?: Maybe<Scalars['String']>;
  articoli: Array<ArticoliNode>;
  articoliGallery?: Maybe<Array<Maybe<ArticoliImmaginiCollezioniObject>>>;
  dataUltMod?: Maybe<Scalars['DateTime']>;
  file: Scalars['String'];
  galleryCollection?: Maybe<CollezioneNode>;
  galleryIspirazioni?: Maybe<IspirazioniNode>;
  id?: Maybe<Scalars['Int']>;
  imageAlt?: Maybe<Scalars['String']>;
  imageDescriptionElaborata?: Maybe<Scalars['String']>;
  imageDescriptionElaborataDe?: Maybe<Scalars['String']>;
  imageDescriptionElaborataEn?: Maybe<Scalars['String']>;
  imageDescriptionElaborataEs?: Maybe<Scalars['String']>;
  imageDescriptionElaborataFr?: Maybe<Scalars['String']>;
  imageDescriptionElaborataIt?: Maybe<Scalars['String']>;
  imageDescriptionElaborataUs?: Maybe<Scalars['String']>;
  imageDescriptionElaborataUsEs?: Maybe<Scalars['String']>;
  imageDescriptionElaborataUsFr?: Maybe<Scalars['String']>;
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  ordinamentoWebAmbienti?: Maybe<Scalars['Int']>;
  ordinamentoWebColori?: Maybe<Scalars['Int']>;
  ordinamentoWebIspirazioni?: Maybe<Scalars['Int']>;
  ordinamentoWebMacroformati?: Maybe<Scalars['Int']>;
  ordinamentoWebPose?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
  visualizzaWebAmbienti?: Maybe<Scalars['Boolean']>;
  visualizzaWebColori?: Maybe<Scalars['Boolean']>;
  visualizzaWebIspirazioni?: Maybe<Scalars['Boolean']>;
  visualizzaWebMacroformati?: Maybe<Scalars['Boolean']>;
  visualizzaWebPose?: Maybe<Scalars['Boolean']>;
  visualizzazioniId: Scalars['Int'];
};

export type ImmaginiProgettiNode = {
  __typename?: 'ImmaginiProgettiNode';
  /** Make this content visible according to Site and Language visibility */
  active?: Maybe<Scalars['Boolean']>;
  /** alt_tag file website marazzi site */
  altTag?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagDe?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagEn?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagEs?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagFr?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagIt?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagUs?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagUsEs?: Maybe<Scalars['String']>;
  /** alt_tag file website marazzi site */
  altTagUsFr?: Maybe<Scalars['String']>;
  dataUltMod?: Maybe<Scalars['DateTime']>;
  /** filename website marazzi site */
  file?: Maybe<Scalars['String']>;
  galleryProgetti?: Maybe<ProgettiNode>;
  id?: Maybe<Scalars['Int']>;
  imageAlt?: Maybe<Scalars['String']>;
  /** ordinamento_web marazzi site */
  ordinamentoWeb: Scalars['Int'];
  /** path file website marazzi site */
  path?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** visualizza_web marazzi site */
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
  /** tipo visualizzazione id website marazzi site */
  visualizzazioniId: Scalars['Int'];
};

export type InfoProgettoCollezioneObject = {
  __typename?: 'InfoProgettoCollezioneObject';
  collezione?: Maybe<CollezioneNode>;
  infoProgetti?: Maybe<Array<Maybe<InfoProgettoNode>>>;
};

export type InfoProgettoNode = {
  __typename?: 'InfoProgettoNode';
  collezione?: Maybe<CollezioneNode>;
  coloreNome?: Maybe<Scalars['String']>;
  finituraNome?: Maybe<Scalars['String']>;
  formato?: Maybe<FormatiNode>;
  id: Scalars['Int'];
  progetto?: Maybe<ProgettiNode>;
  spessore?: Maybe<Scalars['String']>;
  superficie?: Maybe<SuperficiObject>;
  tonalita?: Maybe<TonalitaNode>;
  tonalitaUrl?: Maybe<Scalars['String']>;
};

export type IspirazioniNode = {
  __typename?: 'IspirazioniNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  descriptionSeo?: Maybe<Scalars['String']>;
  descriptionSeoDe?: Maybe<Scalars['String']>;
  descriptionSeoEn?: Maybe<Scalars['String']>;
  descriptionSeoEs?: Maybe<Scalars['String']>;
  descriptionSeoFr?: Maybe<Scalars['String']>;
  descriptionSeoIt?: Maybe<Scalars['String']>;
  descriptionSeoUs?: Maybe<Scalars['String']>;
  descriptionSeoUsEs?: Maybe<Scalars['String']>;
  descriptionSeoUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  galleryIspirazioni: Array<ImmaginiCollezioniNode>;
  id: Scalars['Int'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  ispirazioniCollezioni: Array<CollezioneNode>;
  name: Scalars['String'];
  progressivo: Scalars['Int'];
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeo?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoDe?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoEn?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoEs?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoFr?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoIt?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoUs?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoUsEs?: Maybe<Scalars['String']>;
  /** Testo SEO P */
  testoSeoUsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1De?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1En?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1It?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H1 */
  titoloSeoH1UsFr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2De?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2En?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2Es?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2Fr?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2It?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2Us?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2UsEs?: Maybe<Scalars['String']>;
  /** Titolo SEO H2 */
  titoloSeoH2UsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

export type IspirazioniObject = {
  __typename?: 'IspirazioniObject';
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ListingCollezioniObject = {
  __typename?: 'ListingCollezioniObject';
  attributi?: Maybe<Array<Maybe<ParentFiltroCollezioneObject>>>;
  count?: Maybe<Scalars['Int']>;
  effetti?: Maybe<Array<Maybe<CategoriaNode>>>;
  elementi?: Maybe<Array<Maybe<CollezioneNode>>>;
  ispirazioni?: Maybe<Array<Maybe<MagazineNode>>>;
  numPages?: Maybe<Scalars['Int']>;
  ordinamenti?: Maybe<Array<Maybe<OrdinamentoObject>>>;
  page?: Maybe<Scalars['Int']>;
  params?: Maybe<ParamsListingObject>;
  perPage?: Maybe<Scalars['Int']>;
  suggestions?: Maybe<Array<Maybe<SuggestionObject>>>;
};

export type ListingProgettiObject = {
  __typename?: 'ListingProgettiObject';
  attributi?: Maybe<Array<Maybe<ParentFiltroCollezioneObject>>>;
  count?: Maybe<Scalars['Int']>;
  elementi?: Maybe<Array<Maybe<ProgettiNode>>>;
  numPages?: Maybe<Scalars['Int']>;
  ordinamenti?: Maybe<Array<Maybe<OrdinamentoObject>>>;
  page?: Maybe<Scalars['Int']>;
  params?: Maybe<ParamsListingObject>;
  perPage?: Maybe<Scalars['Int']>;
  suggestions?: Maybe<Array<Maybe<SuggestionObject>>>;
};

export type MacroCategoriaNode = {
  __typename?: 'MacroCategoriaNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  categorie?: Maybe<Array<Maybe<CategoriaNode>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  chiaveRicerca: Scalars['String'];
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  intestazioneListing: Scalars['String'];
  intestazioneListingDe?: Maybe<Scalars['String']>;
  intestazioneListingEn?: Maybe<Scalars['String']>;
  intestazioneListingEs?: Maybe<Scalars['String']>;
  intestazioneListingFr?: Maybe<Scalars['String']>;
  intestazioneListingIt?: Maybe<Scalars['String']>;
  intestazioneListingUs?: Maybe<Scalars['String']>;
  intestazioneListingUsEs?: Maybe<Scalars['String']>;
  intestazioneListingUsFr?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  nome: Scalars['String'];
  nomeDe?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeFr?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  nomeUs?: Maybe<Scalars['String']>;
  nomeUsEs?: Maybe<Scalars['String']>;
  nomeUsFr?: Maybe<Scalars['String']>;
  /** ordinamento */
  ordinamento?: Maybe<Scalars['Int']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  soluzioniMacroCategorie: Array<SoluzioneNode>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

export type MagazineNode = {
  __typename?: 'MagazineNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  abstractTitle?: Maybe<Scalars['String']>;
  abstractTitleDe?: Maybe<Scalars['String']>;
  abstractTitleEn?: Maybe<Scalars['String']>;
  abstractTitleEs?: Maybe<Scalars['String']>;
  abstractTitleFr?: Maybe<Scalars['String']>;
  abstractTitleIt?: Maybe<Scalars['String']>;
  abstractTitleUs?: Maybe<Scalars['String']>;
  abstractTitleUsEs?: Maybe<Scalars['String']>;
  abstractTitleUsFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  categoria?: Maybe<CategoriaMagazineNode>;
  categoriaTitle?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  correlati?: Maybe<Array<Maybe<MagazineNode>>>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooter?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterDe?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterEn?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterEs?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterFr?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterIt?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterUs?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterUsEs?: Maybe<Scalars['String']>;
  /** Parte testuale inferiore */
  descriptionFooterUsFr?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHead?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadDe?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadEn?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadEs?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadFr?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadIt?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadUs?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadUsEs?: Maybe<Scalars['String']>;
  /** Parte testuale superiore */
  descriptionHeadUsFr?: Maybe<Scalars['String']>;
  gallery?: Maybe<Array<Maybe<GalleryItemNode>>>;
  galleryImages: Array<GalleryItemNode>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imagePath: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  /** Make this content visible in the footure for this language */
  inFooter: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterDe: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterEn: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterEs: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterFr: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterIt: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterUs: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterUsEs: Scalars['Boolean'];
  /** Make this content visible in the footure for this language */
  inFooterUsFr: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHome: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeDe: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeEn: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeEs: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeFr: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeIt: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeUs: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeUsEs: Scalars['Boolean'];
  /** Make this content visible in home for this language */
  inHomeUsFr: Scalars['Boolean'];
  magazinebrands: Array<BrandNode>;
  magazinecollezioni: Array<CollezioneNode>;
  magazineprogetti: Array<ProgettiNode>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  /** idold */
  placeholderId: Scalars['Int'];
  premio?: Maybe<Scalars['String']>;
  previewImage?: Maybe<Scalars['String']>;
  pubDate?: Maybe<Scalars['DateTime']>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  /** H2 - Massimo 150 caratteri */
  seoDescription?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionDe?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionEn?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionEs?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionFr?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionIt?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionUs?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  /** H2 - Massimo 150 caratteri */
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitle?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleDe?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleEn?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleEs?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleFr?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleIt?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleUs?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleUsEs?: Maybe<Scalars['String']>;
  /** H1 - Massimo 70 caratteri */
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitleDe?: Maybe<Scalars['String']>;
  subtitleEn?: Maybe<Scalars['String']>;
  subtitleEs?: Maybe<Scalars['String']>;
  subtitleFr?: Maybe<Scalars['String']>;
  subtitleIt?: Maybe<Scalars['String']>;
  subtitleUs?: Maybe<Scalars['String']>;
  subtitleUsEs?: Maybe<Scalars['String']>;
  subtitleUsFr?: Maybe<Scalars['String']>;
  thumbnailPath: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Max 100 caratteri - Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  validityFrom?: Maybe<Scalars['DateTime']>;
  validityTo?: Maybe<Scalars['DateTime']>;
  videoUrl?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
  webguiId: Scalars['String'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export type OpusCodeNode = {
  __typename?: 'OpusCodeNode';
  articolo?: Maybe<ArticoliNode>;
  codiceCatalogo?: Maybe<Scalars['String']>;
  formato?: Maybe<FormatiNode>;
  id: Scalars['ID'];
  numPezzi?: Maybe<Scalars['Int']>;
  opus: OpusNode;
};

export type OpusNode = {
  __typename?: 'OpusNode';
  descrizione?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  opusCodesPerArticoli?: Maybe<Array<Maybe<OpusCodeNode>>>;
  opusCodesPerFormati?: Maybe<Array<Maybe<OpusCodeNode>>>;
  opusOpuscode: Array<OpusCodeNode>;
  path?: Maybe<Scalars['String']>;
};

export type OrdinamentoInputObject = {
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OrdinamentoObject = {
  __typename?: 'OrdinamentoObject';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PagebuilderPlaceholderNode = {
  __typename?: 'PagebuilderPlaceholderNode';
  created?: Maybe<Scalars['DateTime']>;
  draft: Scalars['Boolean'];
  id: Scalars['ID'];
  jsonDraft?: Maybe<Scalars['String']>;
  jsonPublished?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  lang?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  objectId?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PagesPaginaStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

/** An enumeration. */
export enum PagesPaginaTipologiaChoices {
  /** Pagina */
  Page = 'PAGE',
  /** Pagina applicazione */
  PageApp = 'PAGE_APP',
  /** Pagine Entità */
  PageAppMany = 'PAGE_APP_MANY'
}

export type PaginaNode = Node & {
  __typename?: 'PaginaNode';
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  chiave?: Maybe<Scalars['String']>;
  chiaveMenu?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<PaginaNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  hreflangs?: Maybe<Array<Maybe<HrefLangType>>>;
  /** The ID of the object */
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  inRicerca: Scalars['Boolean'];
  inSitemap: Scalars['Boolean'];
  mainImage?: Maybe<Scalars['String']>;
  menuChildren?: Maybe<Array<Maybe<PaginaNode>>>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modificaUrl?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  noindex: Scalars['Boolean'];
  nome?: Maybe<Scalars['String']>;
  nomeDe?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeFr?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  nomeUs?: Maybe<Scalars['String']>;
  nomeUsEs?: Maybe<Scalars['String']>;
  nomeUsFr?: Maybe<Scalars['String']>;
  pageActive: Scalars['Boolean'];
  pageActiveDe: Scalars['Boolean'];
  pageActiveEn: Scalars['Boolean'];
  pageActiveEs: Scalars['Boolean'];
  pageActiveFr: Scalars['Boolean'];
  pageActiveIt: Scalars['Boolean'];
  pageActiveUs: Scalars['Boolean'];
  pageActiveUsEs: Scalars['Boolean'];
  pageActiveUsFr: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  parent?: Maybe<PaginaNode>;
  path?: Maybe<Scalars['String']>;
  pathDe?: Maybe<Scalars['String']>;
  pathEn?: Maybe<Scalars['String']>;
  pathEs?: Maybe<Scalars['String']>;
  pathFr?: Maybe<Scalars['String']>;
  pathIt?: Maybe<Scalars['String']>;
  pathUs?: Maybe<Scalars['String']>;
  pathUsEs?: Maybe<Scalars['String']>;
  pathUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  previewImage?: Maybe<Scalars['String']>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seo?: Maybe<SeoType>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  siblings?: Maybe<Array<Maybe<PaginaNode>>>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: PagesPaginaStatoPubblicazioneChoices;
  template?: Maybe<Scalars['String']>;
  tipologia: PagesPaginaTipologiaChoices;
  titolo: Scalars['String'];
  titoloDe?: Maybe<Scalars['String']>;
  titoloEn?: Maybe<Scalars['String']>;
  titoloEs?: Maybe<Scalars['String']>;
  titoloFr?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  titoloUs?: Maybe<Scalars['String']>;
  titoloUsEs?: Maybe<Scalars['String']>;
  titoloUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
};

export type ParamsListingInputObject = {
  categoriaSlug?: InputMaybe<Scalars['String']>;
  filtri?: InputMaybe<Array<InputMaybe<ParentFiltroCollezioneInputObject>>>;
  ordinamento?: InputMaybe<OrdinamentoInputObject>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type ParamsListingObject = {
  __typename?: 'ParamsListingObject';
  categoriaSlug?: Maybe<Scalars['String']>;
  filtri?: Maybe<Array<Maybe<ParentFiltroCollezioneObject>>>;
  ordinamento?: Maybe<OrdinamentoObject>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

export type ParentFiltroCollezioneInputObject = {
  chiave?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  valori?: InputMaybe<Array<InputMaybe<FiltroCollezioneInputObject>>>;
};

export type ParentFiltroCollezioneObject = {
  __typename?: 'ParentFiltroCollezioneObject';
  chiave?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  valori?: Maybe<Array<Maybe<FiltroCollezioneObject>>>;
};

/** An enumeration. */
export enum ProdottiBrandStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type ProgettiNode = {
  __typename?: 'ProgettiNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  /** altri_materiali progetti marazzi site */
  altriMateriali?: Maybe<Scalars['Boolean']>;
  /** anno progetti marazzi site */
  anno?: Maybe<Scalars['Int']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  cittaId?: Maybe<Scalars['String']>;
  collezioni?: Maybe<Array<Maybe<CollezioneNode>>>;
  copertina?: Maybe<Scalars['String']>;
  correlati?: Maybe<Array<Maybe<ProgettiNode>>>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooter?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterDe?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterEn?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterEs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterFr?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterIt?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterUs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterUsEs?: Maybe<Scalars['String']>;
  /** Footer description of your content */
  descriptionFooterUsFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  destinazione?: Maybe<Scalars['String']>;
  destinazioneTitolo?: Maybe<Scalars['String']>;
  destinazioni?: Maybe<Array<Maybe<DestinazioneUsoNode>>>;
  galleryProgetti: Array<ImmaginiProgettiNode>;
  galleryProgettoDetail?: Maybe<Array<Maybe<ImmaginiProgettiNode>>>;
  /** id progetti marazzi site */
  id: Scalars['Int'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  /** Indirizzo of the progetti marazzi site */
  indirizzo?: Maybe<Scalars['String']>;
  infoProgetti: Array<InfoProgettoNode>;
  infoProgettiCollezione?: Maybe<Array<Maybe<InfoProgettoCollezioneObject>>>;
  /** Link of the progetti marazzi site */
  link?: Maybe<Scalars['String']>;
  magazineprogetti: Array<MagazineNode>;
  /** marazzi_engineering progetti marazzi site */
  marazziEngineering?: Maybe<Scalars['Boolean']>;
  modelPk?: Maybe<Scalars['Int']>;
  /** Name of the progetti marazzi site */
  name?: Maybe<Scalars['String']>;
  /** progressivo progetti marazzi site */
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  premio?: Maybe<Scalars['String']>;
  progettiCollezioni: Array<CollezioneNode>;
  progettiProgetti: Array<ProgettiNode>;
  progettiSet: Array<ProgettiNode>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  soluzioni: Array<SoluzioneNode>;
  sottocategorieprogetti: Array<SottoCategorieNode>;
  /** Sottotitolo of your content */
  sottotitolo?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloDe?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloEn?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloEs?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloFr?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloIt?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloUs?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloUsEs?: Maybe<Scalars['String']>;
  /** Sottotitolo of your content */
  sottotitoloUsFr?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tecnologie: Array<TecnologiaNode>;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titolo?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloDe?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloEn?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloEs?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloFr?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloIt?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloUs?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloUsEs?: Maybe<Scalars['String']>;
  /** Titolo of your content */
  titoloUsFr?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleDe?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEn?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleFr?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleIt?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsFr?: Maybe<Scalars['Boolean']>;
  /** visualizza_web progetti marazzi site */
  visualizzaWeb?: Maybe<Scalars['Boolean']>;
};

export type QueryGet = {
  __typename?: 'QueryGet';
  listingCollezioni?: Maybe<ListingCollezioniObject>;
  listingProgetti?: Maybe<ListingProgettiObject>;
};


export type QueryGetListingCollezioniArgs = {
  params?: InputMaybe<ParamsListingInputObject>;
};


export type QueryGetListingProgettiArgs = {
  params?: InputMaybe<ParamsListingInputObject>;
};

export type SeoType = {
  __typename?: 'SeoType';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  noindex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type ShadeVariationNode = {
  __typename?: 'ShadeVariationNode';
  active?: Maybe<Scalars['Boolean']>;
  codice?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type SoluzioneNode = {
  __typename?: 'SoluzioneNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  categorie?: Maybe<Array<Maybe<CategoriaNode>>>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  correlati?: Maybe<Array<Maybe<SoluzioneNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  destinazioniUso?: Maybe<Array<Maybe<DestinazioneSoluzioneNode>>>;
  destinazionisoluzioni: Array<DestinazioneSoluzioneNode>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  linkVideo?: Maybe<Scalars['String']>;
  linkVideoDe?: Maybe<Scalars['String']>;
  linkVideoEn?: Maybe<Scalars['String']>;
  linkVideoEs?: Maybe<Scalars['String']>;
  linkVideoFr?: Maybe<Scalars['String']>;
  linkVideoIt?: Maybe<Scalars['String']>;
  linkVideoUs?: Maybe<Scalars['String']>;
  linkVideoUsEs?: Maybe<Scalars['String']>;
  linkVideoUsFr?: Maybe<Scalars['String']>;
  macroCategorie?: Maybe<Array<Maybe<MacroCategoriaNode>>>;
  macroCategories: Array<MacroCategoriaNode>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  ordinamento?: Maybe<Scalars['Int']>;
  pageActive: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  placeholderId: Scalars['Int'];
  previewImage?: Maybe<Scalars['String']>;
  progetti: Array<ProgettiNode>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: SoluzioniSoluzioneStatoPubblicazioneChoices;
  subtitle?: Maybe<Scalars['String']>;
  subtitleH1?: Maybe<Scalars['String']>;
  subtitleH1De?: Maybe<Scalars['String']>;
  subtitleH1En?: Maybe<Scalars['String']>;
  subtitleH1Es?: Maybe<Scalars['String']>;
  subtitleH1Fr?: Maybe<Scalars['String']>;
  subtitleH1It?: Maybe<Scalars['String']>;
  subtitleH1Us?: Maybe<Scalars['String']>;
  subtitleH1UsEs?: Maybe<Scalars['String']>;
  subtitleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  title: Scalars['String'];
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  titleH1?: Maybe<Scalars['String']>;
  titleH1De?: Maybe<Scalars['String']>;
  titleH1En?: Maybe<Scalars['String']>;
  titleH1Es?: Maybe<Scalars['String']>;
  titleH1Fr?: Maybe<Scalars['String']>;
  titleH1It?: Maybe<Scalars['String']>;
  titleH1Us?: Maybe<Scalars['String']>;
  titleH1UsEs?: Maybe<Scalars['String']>;
  titleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  titolo: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

/** An enumeration. */
export enum SoluzioniSoluzioneStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type SottoCategorieNode = {
  __typename?: 'SottoCategorieNode';
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  /** code */
  codice: Scalars['String'];
  /** id */
  id: Scalars['Int'];
  /** nome */
  nome: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  sottocategorieprogetti: Array<ProgettiNode>;
  title?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleDe?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleEn?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleEs?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleFr?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleIt?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleUs?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleUsEs?: Maybe<Scalars['String']>;
  /** title sottocategoria website marazzi site */
  titleUsFr?: Maybe<Scalars['String']>;
};

export type SpessoriFormatiObject = {
  __typename?: 'SpessoriFormatiObject';
  codice?: Maybe<Scalars['String']>;
  formati?: Maybe<Array<Maybe<FormatiSpessoriObject>>>;
  spessore?: Maybe<Scalars['String']>;
};

export type SuggestionObject = {
  __typename?: 'SuggestionObject';
  id?: Maybe<Scalars['Int']>;
  modelName?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SuperficiObject = {
  __typename?: 'SuperficiObject';
  bcra?: Maybe<Scalars['String']>;
  dcof?: Maybe<Scalars['String']>;
  dinscivolosita?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  pendoloAS4586?: Maybe<Scalars['String']>;
  pendoloBS7976?: Maybe<Scalars['String']>;
  pendoloUNE41901?: Maybe<Scalars['String']>;
  scivolositaLabel?: Maybe<Scalars['String']>;
  scivolositaNome?: Maybe<Scalars['String']>;
  specificheAbcLabel?: Maybe<Scalars['String']>;
  specificheAbcNome?: Maybe<Scalars['String']>;
  spessori?: Maybe<Array<Maybe<SpessoriFormatiObject>>>;
};

export type SuperficieNode = {
  __typename?: 'SuperficieNode';
  descrizione?: Maybe<Scalars['String']>;
  descrizioneDe?: Maybe<Scalars['String']>;
  descrizioneEn?: Maybe<Scalars['String']>;
  descrizioneEs?: Maybe<Scalars['String']>;
  descrizioneFr?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  descrizioneUs?: Maybe<Scalars['String']>;
  descrizioneUsEs?: Maybe<Scalars['String']>;
  descrizioneUsFr?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  infoProgetti: Array<InfoProgettoNode>;
  nome: Scalars['String'];
  nomeDe?: Maybe<Scalars['String']>;
  nomeEn?: Maybe<Scalars['String']>;
  nomeEs?: Maybe<Scalars['String']>;
  nomeFr?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  nomeUs?: Maybe<Scalars['String']>;
  nomeUsEs?: Maybe<Scalars['String']>;
  nomeUsFr?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  superficiarticoli: Array<ArticoliNode>;
  superficieArticles: Array<ArticoliNode>;
};

export type TecnologiaNode = {
  __typename?: 'TecnologiaNode';
  /** Short textual description of your content */
  abstract?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractDe?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEn?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractFr?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractIt?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsEs?: Maybe<Scalars['String']>;
  /** Short textual description of your content */
  abstractUsFr?: Maybe<Scalars['String']>;
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  adminUrl?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  altDe?: Maybe<Scalars['String']>;
  altEn?: Maybe<Scalars['String']>;
  altEs?: Maybe<Scalars['String']>;
  altFr?: Maybe<Scalars['String']>;
  altIt?: Maybe<Scalars['String']>;
  altUs?: Maybe<Scalars['String']>;
  altUsEs?: Maybe<Scalars['String']>;
  altUsFr?: Maybe<Scalars['String']>;
  changedBy?: Maybe<UtenteNode>;
  changedDate?: Maybe<Scalars['DateTime']>;
  correlati?: Maybe<Array<Maybe<TecnologiaNode>>>;
  created?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UtenteNode>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Main textual description of your content */
  description?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionDe?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEn?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionFr?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionIt?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsEs?: Maybe<Scalars['String']>;
  /** Main textual description of your content */
  descriptionUsFr?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageAlt?: Maybe<Scalars['String']>;
  linkVideo?: Maybe<Scalars['String']>;
  linkVideoDe?: Maybe<Scalars['String']>;
  linkVideoEn?: Maybe<Scalars['String']>;
  linkVideoEs?: Maybe<Scalars['String']>;
  linkVideoFr?: Maybe<Scalars['String']>;
  linkVideoIt?: Maybe<Scalars['String']>;
  linkVideoUs?: Maybe<Scalars['String']>;
  linkVideoUsEs?: Maybe<Scalars['String']>;
  linkVideoUsFr?: Maybe<Scalars['String']>;
  listingImage?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['Int']>;
  modelClass?: Maybe<Scalars['String']>;
  modified?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  ordinamento?: Maybe<Scalars['Int']>;
  pageActive: Scalars['Boolean'];
  pagebuilders?: Maybe<Array<Maybe<PagebuilderPlaceholderNode>>>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  placeholderId: Scalars['Int'];
  previewImage?: Maybe<Scalars['String']>;
  progetti: Array<ProgettiNode>;
  pubblicato?: Maybe<Scalars['Boolean']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionDe?: Maybe<Scalars['String']>;
  seoDescriptionEn?: Maybe<Scalars['String']>;
  seoDescriptionEs?: Maybe<Scalars['String']>;
  seoDescriptionFr?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoDescriptionUs?: Maybe<Scalars['String']>;
  seoDescriptionUsEs?: Maybe<Scalars['String']>;
  seoDescriptionUsFr?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleDe?: Maybe<Scalars['String']>;
  seoTitleEn?: Maybe<Scalars['String']>;
  seoTitleEs?: Maybe<Scalars['String']>;
  seoTitleFr?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  seoTitleUs?: Maybe<Scalars['String']>;
  seoTitleUsEs?: Maybe<Scalars['String']>;
  seoTitleUsFr?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  statoPubblicazione: TecnologieTecnologiaStatoPubblicazioneChoices;
  subtitle?: Maybe<Scalars['String']>;
  subtitleH1?: Maybe<Scalars['String']>;
  subtitleH1De?: Maybe<Scalars['String']>;
  subtitleH1En?: Maybe<Scalars['String']>;
  subtitleH1Es?: Maybe<Scalars['String']>;
  subtitleH1Fr?: Maybe<Scalars['String']>;
  subtitleH1It?: Maybe<Scalars['String']>;
  subtitleH1Us?: Maybe<Scalars['String']>;
  subtitleH1UsEs?: Maybe<Scalars['String']>;
  subtitleH1UsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescription?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionDe?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEn?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionFr?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionIt?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsEs?: Maybe<Scalars['String']>;
  /** Title of the description of your content */
  titleDescriptionUsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEn?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleFr?: Maybe<Scalars['String']>;
  titleH1?: Maybe<Scalars['String']>;
  titleH1De?: Maybe<Scalars['String']>;
  titleH1En?: Maybe<Scalars['String']>;
  titleH1Es?: Maybe<Scalars['String']>;
  titleH1Fr?: Maybe<Scalars['String']>;
  titleH1It?: Maybe<Scalars['String']>;
  titleH1Us?: Maybe<Scalars['String']>;
  titleH1UsEs?: Maybe<Scalars['String']>;
  titleH1UsFr?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleIt?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsEs?: Maybe<Scalars['String']>;
  /** Title of your content */
  titleUsFr?: Maybe<Scalars['String']>;
  titolo: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  visibilitaDal?: Maybe<Scalars['String']>;
  /** Make this content visible for this language */
  visible: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleDe: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEn: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleFr: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleIt: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsEs: Scalars['Boolean'];
  /** Make this content visible for this language */
  visibleUsFr: Scalars['Boolean'];
};

/** An enumeration. */
export enum TecnologieTecnologiaStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type TipologieNode = {
  __typename?: 'TipologieNode';
  /** Make this content visible according to Site and Language visibility */
  active: Scalars['Boolean'];
  codice?: Maybe<Scalars['String']>;
  documentiBrand: Array<DocumentiBrandNode>;
  downloadWeb?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  onlineWeb?: Maybe<Scalars['Boolean']>;
  ordinamentoWeb?: Maybe<Scalars['Int']>;
  tipologiedocumenti: Array<DocumentiCollezioniNode>;
  title?: Maybe<Scalars['String']>;
  titleDe?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  titleEs?: Maybe<Scalars['String']>;
  titleFr?: Maybe<Scalars['String']>;
  titleIt?: Maybe<Scalars['String']>;
  titleUs?: Maybe<Scalars['String']>;
  titleUsEs?: Maybe<Scalars['String']>;
  titleUsFr?: Maybe<Scalars['String']>;
  visualizzaArticoli?: Maybe<Scalars['Boolean']>;
  visualizzaCollezioni?: Maybe<Scalars['Boolean']>;
  visualizzaProgetti?: Maybe<Scalars['Boolean']>;
};

export type TonalitaCollezioneNode = {
  __typename?: 'TonalitaCollezioneNode';
  articolo?: Maybe<ArticoliNode>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  certificazioni?: Maybe<Array<Maybe<CaratteristicheNode>>>;
  collezione: CollezioneNode;
  gallery?: Maybe<Array<Maybe<ImmaginiCollezioniNode>>>;
  id: Scalars['ID'];
  modelPk?: Maybe<Scalars['Int']>;
  ordinamento?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  slugBrand?: Maybe<Scalars['String']>;
  slugCollezione?: Maybe<Scalars['String']>;
  superficiSpessoriFormati?: Maybe<Array<Maybe<SuperficiObject>>>;
  tonalita: TonalitaNode;
  tonalitaNome?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TonalitaColoriImageObject = {
  __typename?: 'TonalitaColoriImageObject';
  alt?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TonalitaColoriObject = {
  __typename?: 'TonalitaColoriObject';
  image?: Maybe<TonalitaColoriImageObject>;
  nome?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TonalitaNode = {
  __typename?: 'TonalitaNode';
  active?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  infoProgetti: Array<InfoProgettoNode>;
  nome?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  slugDe?: Maybe<Scalars['String']>;
  slugEn?: Maybe<Scalars['String']>;
  slugEs?: Maybe<Scalars['String']>;
  slugFr?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  slugUs?: Maybe<Scalars['String']>;
  slugUsEs?: Maybe<Scalars['String']>;
  slugUsFr?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tonalitaArticles: Array<ArticoliNode>;
  tonalitacollezioni: Array<CollezioneNode>;
  /** Make this content visible for this language */
  visible?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleDe?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEn?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleFr?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleIt?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsEs?: Maybe<Scalars['Boolean']>;
  /** Make this content visible for this language */
  visibleUsFr?: Maybe<Scalars['Boolean']>;
  xTonalitaCollezioni: Array<TonalitaCollezioneNode>;
};

export type UtenteNode = Node & {
  __typename?: 'UtenteNode';
  cognome?: Maybe<Scalars['String']>;
  dateJoined: Scalars['DateTime'];
  edit?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Stabilisce se l'utente debba essere considerato attivo. Deseleziona qui, piuttosto che cancellare gli account. */
  isActive: Scalars['Boolean'];
  /** Stabilisce se l'utente può accedere a questo sito di amministrazione. */
  isStaff: Scalars['Boolean'];
  /** Attribuisce all'utente tutti i privilegi, senza che sia necessario assegnarli esplicitamente. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  magazineMagazineChangedByRelated: Array<MagazineNode>;
  magazineMagazineOwnerRelated: Array<MagazineNode>;
  nome?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  prodottiArticoliChangedByRelated: Array<ArticoliNode>;
  prodottiArticoliOwnerRelated: Array<ArticoliNode>;
  prodottiBrandChangedByRelated: Array<BrandNode>;
  prodottiBrandOwnerRelated: Array<BrandNode>;
  prodottiCategoriaChangedByRelated: Array<CategoriaNode>;
  prodottiCategoriaOwnerRelated: Array<CategoriaNode>;
  prodottiCollezioniChangedByRelated: Array<CollezioneNode>;
  prodottiCollezioniOwnerRelated: Array<CollezioneNode>;
  prodottiIspirazioniChangedByRelated: Array<IspirazioniNode>;
  prodottiIspirazioniOwnerRelated: Array<IspirazioniNode>;
  prodottiMacrocategoriaChangedByRelated: Array<MacroCategoriaNode>;
  prodottiMacrocategoriaOwnerRelated: Array<MacroCategoriaNode>;
  prodottiProgettiChangedByRelated: Array<ProgettiNode>;
  prodottiProgettiOwnerRelated: Array<ProgettiNode>;
  showToolbar?: Maybe<Scalars['Boolean']>;
  soluzioniSoluzioneChangedByRelated: Array<SoluzioneNode>;
  soluzioniSoluzioneOwnerRelated: Array<SoluzioneNode>;
  tecnologieTecnologiaChangedByRelated: Array<TecnologiaNode>;
  tecnologieTecnologiaOwnerRelated: Array<TecnologiaNode>;
  /** Obbligatorio. 150 caratteri o meno.Solo lettere, cifre e @/./+/-/_ */
  username: Scalars['String'];
};

export type ListingCollezioniQueryVariables = Exact<{
  params: ParamsListingInputObject;
}>;


export type ListingCollezioniQuery = { __typename?: 'QueryGet', listingCollezioni?: { __typename?: 'ListingCollezioniObject', page?: number | null, perPage?: number | null, numPages?: number | null, count?: number | null, elementi?: Array<{ __typename?: 'CollezioneNode', pk?: number | null, title: string, slug: string, url?: string | null, quickship?: boolean | null, isUsa?: boolean | null, novita?: boolean | null, listingImage?: { __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null, imageAlt?: string | null } | null, brand?: { __typename?: 'BrandNode', nome?: string | null, logoTransparent?: string | null } | null, categoriaEffetto?: { __typename?: 'CategoriaNode', slug: string } | null } | null> | null, suggestions?: Array<{ __typename?: 'SuggestionObject', id?: number | null, modelName?: string | null, text?: string | null, url?: string | null } | null> | null, attributi?: Array<{ __typename?: 'ParentFiltroCollezioneObject', label?: string | null, chiave?: string | null, valori?: Array<{ __typename?: 'FiltroCollezioneObject', id?: number | null, label?: string | null, valori?: Array<{ __typename?: 'FiltroValoreObject', id?: number | null, label?: string | null, chiave?: string | null } | null> | null } | null> | null } | null> | null, params?: { __typename?: 'ParamsListingObject', search?: string | null, page?: number | null, perPage?: number | null, categoriaSlug?: string | null, filtri?: Array<{ __typename?: 'ParentFiltroCollezioneObject', label?: string | null, chiave?: string | null, valori?: Array<{ __typename?: 'FiltroCollezioneObject', id?: number | null, label?: string | null, valori?: Array<{ __typename?: 'FiltroValoreObject', id?: number | null, label?: string | null, chiave?: string | null } | null> | null } | null> | null } | null> | null, ordinamento?: { __typename?: 'OrdinamentoObject', label?: string | null, value?: string | null } | null } | null, ordinamenti?: Array<{ __typename?: 'OrdinamentoObject', label?: string | null, value?: string | null } | null> | null } | null };

export type ListingCollezioniCompletaQueryVariables = Exact<{
  params: ParamsListingInputObject;
}>;


export type ListingCollezioniCompletaQuery = { __typename?: 'QueryGet', listingCollezioni?: { __typename?: 'ListingCollezioniObject', page?: number | null, perPage?: number | null, numPages?: number | null, count?: number | null, elementi?: Array<{ __typename?: 'CollezioneNode', pk?: number | null, title: string, slug: string, url?: string | null, quickship?: boolean | null, isUsa?: boolean | null, novita?: boolean | null, listingImage?: { __typename?: 'ImmaginiCollezioniNode', id?: number | null, url?: string | null, imageAlt?: string | null } | null, brand?: { __typename?: 'BrandNode', nome?: string | null, logoTransparent?: string | null } | null, categoriaEffetto?: { __typename?: 'CategoriaNode', slug: string } | null } | null> | null, suggestions?: Array<{ __typename?: 'SuggestionObject', id?: number | null, modelName?: string | null, text?: string | null, url?: string | null } | null> | null, attributi?: Array<{ __typename?: 'ParentFiltroCollezioneObject', label?: string | null, chiave?: string | null, valori?: Array<{ __typename?: 'FiltroCollezioneObject', id?: number | null, label?: string | null, valori?: Array<{ __typename?: 'FiltroValoreObject', id?: number | null, label?: string | null, chiave?: string | null } | null> | null } | null> | null } | null> | null, params?: { __typename?: 'ParamsListingObject', search?: string | null, page?: number | null, perPage?: number | null, categoriaSlug?: string | null, filtri?: Array<{ __typename?: 'ParentFiltroCollezioneObject', label?: string | null, chiave?: string | null, valori?: Array<{ __typename?: 'FiltroCollezioneObject', id?: number | null, label?: string | null, valori?: Array<{ __typename?: 'FiltroValoreObject', id?: number | null, label?: string | null, chiave?: string | null } | null> | null } | null> | null } | null> | null, ordinamento?: { __typename?: 'OrdinamentoObject', label?: string | null, value?: string | null } | null } | null, ordinamenti?: Array<{ __typename?: 'OrdinamentoObject', label?: string | null, value?: string | null } | null> | null, effetti?: Array<{ __typename?: 'CategoriaNode', title: string, slug: string, mainImage?: string | null, imageAlt?: string | null, url?: string | null } | null> | null, ispirazioni?: Array<{ __typename?: 'MagazineNode', pk?: number | null, title?: string | null, slug?: string | null, categoriaTitle?: string | null, description?: string | null, imageUrl?: string | null, imageAlt?: string | null, url?: string | null } | null> | null } | null };

export type ListingProgettiQueryVariables = Exact<{
  params: ParamsListingInputObject;
}>;


export type ListingProgettiQuery = { __typename?: 'QueryGet', listingProgetti?: { __typename?: 'ListingProgettiObject', page?: number | null, perPage?: number | null, numPages?: number | null, count?: number | null, elementi?: Array<{ __typename?: 'ProgettiNode', title?: string | null, premio?: string | null, imageUrl?: string | null, description?: string | null, sottotitolo?: string | null, url?: string | null, imageAlt?: string | null, destinazioni?: Array<{ __typename?: 'DestinazioneUsoNode', id?: string | null, titolo?: string | null, slug?: string | null } | null> | null } | null> | null, suggestions?: Array<{ __typename?: 'SuggestionObject', id?: number | null, modelName?: string | null, text?: string | null, url?: string | null } | null> | null, attributi?: Array<{ __typename?: 'ParentFiltroCollezioneObject', label?: string | null, chiave?: string | null, valori?: Array<{ __typename?: 'FiltroCollezioneObject', id?: number | null, label?: string | null, valori?: Array<{ __typename?: 'FiltroValoreObject', id?: number | null, label?: string | null } | null> | null } | null> | null } | null> | null, params?: { __typename?: 'ParamsListingObject', search?: string | null, page?: number | null, perPage?: number | null, filtri?: Array<{ __typename?: 'ParentFiltroCollezioneObject', label?: string | null, chiave?: string | null, valori?: Array<{ __typename?: 'FiltroCollezioneObject', id?: number | null, label?: string | null, valori?: Array<{ __typename?: 'FiltroValoreObject', id?: number | null, label?: string | null } | null> | null } | null> | null } | null> | null, ordinamento?: { __typename?: 'OrdinamentoObject', label?: string | null, value?: string | null } | null } | null, ordinamenti?: Array<{ __typename?: 'OrdinamentoObject', label?: string | null, value?: string | null } | null> | null } | null };


export const ListingCollezioniDocument = gql`
    query ListingCollezioni($params: ParamsListingInputObject!) {
  listingCollezioni(params: $params) {
    elementi {
      pk
      title
      slug
      url
      quickship
      isUsa
      novita
      listingImage {
        id
        url
        imageAlt
      }
      brand {
        nome
        logoTransparent
      }
      categoriaEffetto {
        slug
      }
    }
    suggestions {
      id
      modelName
      text
      url
    }
    attributi {
      label
      chiave
      valori {
        id
        label
        valori {
          id
          label
          chiave
        }
      }
    }
    params {
      search
      filtri {
        label
        chiave
        valori {
          id
          label
          valori {
            id
            label
            chiave
          }
        }
      }
      ordinamento {
        label
        value
      }
      page
      perPage
      categoriaSlug
    }
    ordinamenti {
      label
      value
    }
    page
    perPage
    numPages
    count
  }
}
    `;

/**
 * __useListingCollezioniQuery__
 *
 * To run a query within a React component, call `useListingCollezioniQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingCollezioniQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingCollezioniQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListingCollezioniQuery(baseOptions: Apollo.QueryHookOptions<ListingCollezioniQuery, ListingCollezioniQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingCollezioniQuery, ListingCollezioniQueryVariables>(ListingCollezioniDocument, options);
      }
export function useListingCollezioniLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingCollezioniQuery, ListingCollezioniQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingCollezioniQuery, ListingCollezioniQueryVariables>(ListingCollezioniDocument, options);
        }
export type ListingCollezioniQueryHookResult = ReturnType<typeof useListingCollezioniQuery>;
export type ListingCollezioniLazyQueryHookResult = ReturnType<typeof useListingCollezioniLazyQuery>;
export type ListingCollezioniQueryResult = Apollo.QueryResult<ListingCollezioniQuery, ListingCollezioniQueryVariables>;
export const ListingCollezioniCompletaDocument = gql`
    query ListingCollezioniCompleta($params: ParamsListingInputObject!) {
  listingCollezioni(params: $params) {
    elementi {
      pk
      title
      slug
      url
      quickship
      isUsa
      novita
      listingImage {
        id
        url
        imageAlt
      }
      brand {
        nome
        logoTransparent
      }
      categoriaEffetto {
        slug
      }
    }
    suggestions {
      id
      modelName
      text
      url
    }
    attributi {
      label
      chiave
      valori {
        id
        label
        valori {
          id
          label
          chiave
        }
      }
    }
    params {
      search
      filtri {
        label
        chiave
        valori {
          id
          label
          valori {
            id
            label
            chiave
          }
        }
      }
      ordinamento {
        label
        value
      }
      page
      perPage
      categoriaSlug
    }
    ordinamenti {
      label
      value
    }
    page
    perPage
    numPages
    count
    effetti {
      title
      slug
      mainImage
      imageAlt
      url
    }
    ispirazioni {
      pk
      title
      slug
      categoriaTitle
      description
      imageUrl
      imageAlt
      url
    }
  }
}
    `;

/**
 * __useListingCollezioniCompletaQuery__
 *
 * To run a query within a React component, call `useListingCollezioniCompletaQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingCollezioniCompletaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingCollezioniCompletaQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListingCollezioniCompletaQuery(baseOptions: Apollo.QueryHookOptions<ListingCollezioniCompletaQuery, ListingCollezioniCompletaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingCollezioniCompletaQuery, ListingCollezioniCompletaQueryVariables>(ListingCollezioniCompletaDocument, options);
      }
export function useListingCollezioniCompletaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingCollezioniCompletaQuery, ListingCollezioniCompletaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingCollezioniCompletaQuery, ListingCollezioniCompletaQueryVariables>(ListingCollezioniCompletaDocument, options);
        }
export type ListingCollezioniCompletaQueryHookResult = ReturnType<typeof useListingCollezioniCompletaQuery>;
export type ListingCollezioniCompletaLazyQueryHookResult = ReturnType<typeof useListingCollezioniCompletaLazyQuery>;
export type ListingCollezioniCompletaQueryResult = Apollo.QueryResult<ListingCollezioniCompletaQuery, ListingCollezioniCompletaQueryVariables>;
export const ListingProgettiDocument = gql`
    query ListingProgetti($params: ParamsListingInputObject!) {
  listingProgetti(params: $params) {
    elementi {
      title
      premio
      imageUrl
      description
      sottotitolo
      destinazioni {
        id
        titolo
        slug
      }
      url
      imageAlt
    }
    suggestions {
      id
      modelName
      text
      url
    }
    attributi {
      label
      chiave
      valori {
        id
        label
        valori {
          id
          label
        }
      }
    }
    params {
      search
      filtri {
        label
        chiave
        valori {
          id
          label
          valori {
            id
            label
          }
        }
      }
      ordinamento {
        label
        value
      }
      page
      perPage
    }
    ordinamenti {
      label
      value
    }
    page
    perPage
    numPages
    count
  }
}
    `;

/**
 * __useListingProgettiQuery__
 *
 * To run a query within a React component, call `useListingProgettiQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingProgettiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingProgettiQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListingProgettiQuery(baseOptions: Apollo.QueryHookOptions<ListingProgettiQuery, ListingProgettiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingProgettiQuery, ListingProgettiQueryVariables>(ListingProgettiDocument, options);
      }
export function useListingProgettiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingProgettiQuery, ListingProgettiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingProgettiQuery, ListingProgettiQueryVariables>(ListingProgettiDocument, options);
        }
export type ListingProgettiQueryHookResult = ReturnType<typeof useListingProgettiQuery>;
export type ListingProgettiLazyQueryHookResult = ReturnType<typeof useListingProgettiLazyQuery>;
export type ListingProgettiQueryResult = Apollo.QueryResult<ListingProgettiQuery, ListingProgettiQueryVariables>;